import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { addNewRelicPageAction } from 'ddc-new-relic';
import './EventViewer.scss';

// drag it around: https://www.kirupa.com/html5/drag.htm

const handleBeforeUnload = (event) => {
	const e = event;
	e.returnValue = 'Are you sure you want to leave?';
};

export default function EventViewer(props) {
	const [eventViewerShowing, setEventViewerShowing] = useState(null);
	useEffect(() => {
		// monitor usage of eventViewer fuctionality
		// if there is a huge spike in activity could be a bug in how it shows
		addNewRelicPageAction('ws-tagging-event-viewer');
		window.addEventListener('beforeunload', handleBeforeUnload);
		return () =>
			window.removeEventListener('beforeunload', handleBeforeUnload);
	}, []);

	return ReactDOM.createPortal(
		<div
			className="ws-tagging-event-viewer bg-white position-fixed ml-3 mt-3"
			placeholder="EventViewer"
		>
			<div className="ev-header text-brand-primary text-center font-weight-bold ddc-font-size-large border-bottom bg-light">
				Event Viewer
			</div>
			<div
				className="ws-tagging-heading-button ws-tagging-close-button position-fixed"
				onClick={() => {
					const parentElem = document.querySelector(
						'.ws-tagging-event-viewer'
					);
					parentElem.classList.toggle(
						'ws-tagging-event-viewer--hidden'
					);
					setEventViewerShowing(!eventViewerShowing);
				}}
				role="button"
				aria-hidden="true"
			>
				{eventViewerShowing ? 'Show' : 'Hide'}
			</div>
			<div
				className="ws-tagging-heading-button ws-tagging-clear-button position-absolute"
				onClick={props.clearEventViewer}
				role="button"
				aria-hidden="true"
			>
				Clear
			</div>
			<div className="events-wrapper mx-2">
				{props.data.map(({ detail, eventViewerCount }) => {
					const { classes, diff, ...detailToShow } = detail;

					const attributes = {
						className: classes
					};

					return (
						<div key={eventViewerCount} {...attributes}>
							<div className="text-black">{eventViewerCount}</div>
							<pre>
								{JSON.stringify(
									{
										...detailToShow
									},
									null,
									2
								)}
							</pre>
							{diff && (
								<pre className="text-danger">
									{JSON.stringify(diff, null, 2)}
								</pre>
							)}
						</div>
					);
				})}
			</div>
		</div>,
		document.getElementsByTagName('body')[0]
	);
}

EventViewer.propTypes = {
	data: PropTypes.arrayOf(PropTypes.shape)
};

// only export if the test framework is running
export const exportedForTesting = {
	...(typeof test !== 'undefined' && {
		handleBeforeUnload
	})
};
